<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៦.ក ៦.ខ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <community :data="com_par" :title="title[1]" />
            <financial :data="fin_anc" :title="title[2]" :lst_acc="lst_acc" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import Community from "@/components/privateascf/compre/community.vue";
import Financial from "@/components/privateascf/compre/compreFinancial.vue";

export default {
  props: ["title", "com_par", "fin_anc", "lst_acc"],
  components: {
    community: Community,
    financial: Financial,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>